import {
	GET_SCHOOL_TYPES,
	GET_TENANT_CONSENT
} from 'actions/tenants';

const INITIAL_STATE = {
	schoolTypes: [],
	tenantConsent: null
}

export default function (state = INITIAL_STATE, action) {
	switch (action.type) {
		case GET_SCHOOL_TYPES:
			return { ...state, schoolTypes: action.payload ?? [] };
		case GET_TENANT_CONSENT:
			return { ...state, tenantConsent: action.payload ?? null };
		default:
			return state;
	}
};
